import axios from './financeiroApi';

const PATH = '/api/v1/backend/pais';

const paisApi = {
  get: () => axios.get(`${PATH}?size=300`),
  pesquisarPorNomeECodigo: (params) => axios.get(`${PATH}/pesquisar`, { params }),
};

export { paisApi };
